import { loadStripe } from '@stripe/stripe-js';


// Stripe publishable key for TESTING
// Make sure you're using test card numbers when testing
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51S3J2jDds8J65DphDaDVHCd4W6CyNDo8PYTA5UDGEI9G9VvOrdumLiSqg1EIO8HFcSQB6YTqzTVTFH0pyEoKuyWo00Rwd4iSa5');

export default stripePromise;
